var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Item } from "./components/Item/Item";
import { StyledNavigation, StyledNavigationContainer, } from "./Navigation.styled";
export var Navigation = function (_a) {
    var items = _a.items;
    return (_jsx(StyledNavigationContainer, { children: _jsx(StyledNavigation, { children: items.map(function (item, index) { return (_createElement(Item, __assign({}, item, { key: "".concat(index, "Item") }))); }) }) }));
};
